module.exports = __webpack_public_path__ + "static/media/pc-build.a6772926.png";